import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const container = css`
  display: grid;
  grid-template-columns: fit-content(160px) 1fr;
  column-gap: var(${spacing.sm});
`;

export const attributeItem = css`
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  font-family: var(${typography.body.fontFamily});
  font-weight: var(${typography.body.fontWeight});
  padding: var(${spacing.md}) 0;
  border-bottom: 1px solid var(${colors.stroke.default});

  b {
    font-weight: 700;
  }
`;

export const heading = css`
  margin: 0 0 var(${spacing.md});
  font-family: var(${typography.heading.fontFamily});
  font-size: var(${typography.heading.sizes.md.fontSize});
  line-height: var(${typography.heading.sizes.md.lineHeight});
  font-weight: var(${typography.heading.fontWeight});
  color: var(${colors.content.default});
  padding-bottom: var(${spacing.md});
  border-bottom: 1px solid var(${colors.stroke.default});
`;
